module.exports = __webpack_public_path__ + "img/wedding-rings-gold.2c166486.svg";